import React from "react";
import {
  ChatBubble,
  ChatBubbleOutlineOutlined,
} from "@mui/icons-material";

export const POST_LIKE_ICON_URL = "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/1d169027-443a-4f85-8c7d-707000933f00/public";
export const POST_LIKED_ICON_URL = "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/b0d6f7b5-d727-4f1d-cda5-a1cf207eae00/public";
export const POST_SHARE_ICON_URL = "https://imagedelivery.net/mEHe7vWpwEHOhne-YSqzMw/91301ff3-393c-42b0-6a3f-f4790206be00/public";

const ProfileGalleryPostActionIcon = ({ type, active = false, className = "profile-gallery-post-action-icon" }) => {
  if (type === "like") {
    return (
      <img
        src={active ? POST_LIKED_ICON_URL : POST_LIKE_ICON_URL}
        alt=""
        className={className}
        aria-hidden="true"
      />
    );
  }

  if (type === "comment") {
    return active
      ? <ChatBubble className={className} aria-hidden="true" />
      : <ChatBubbleOutlineOutlined className={className} aria-hidden="true" />;
  }

  if (type === "share") {
    return (
      <img
        src={POST_SHARE_ICON_URL}
        alt=""
        className={className}
        aria-hidden="true"
      />
    );
  }

  return null;
};

export default ProfileGalleryPostActionIcon;